import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "./EventDetails.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import RecentBlogs from "./RecentBlogs/RecentBlogs";

const EventDetails = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/events/${id}`);
        setEvent(data);
        window.scrollTo(0, 0);
      } catch (error) {
        console.error("Error fetching event:", error);
      }
    };
    fetchEvent();
  }, [id]);

  if (!event) return <p>Loading...</p>;

  return (
    <>
      <Header />
      <div className="event-details-container">
        <div className="event-main">
          <h1 className="event-title">{event.title}</h1>

          {event.image && (
            <img
              src={event.image}
              alt={event.title}
              className="event-image"
            />
          )}
          <p className="created-date">
            🗓️ <b>Created on:</b>{" "}
            {new Date(event.createdAt).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            })}
          </p>




          <div className="event-full-description">
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} >
              {event.fullDescription}
            </ReactMarkdown>
          </div>
        </div>

        <div id="details-sidebar-section">
          <RecentBlogs />
        </div>

      </div>
      <Footer />
    </>
  );
};

export default EventDetails;
